import { render } from "./PlotRentAdjustmentApprovals.vue?vue&type=template&id=27bfb399&scoped=true"
import script from "./PlotRentAdjustmentApprovals.vue?vue&type=script&lang=js"
export * from "./PlotRentAdjustmentApprovals.vue?vue&type=script&lang=js"

import "./PlotRentAdjustmentApprovals.vue?vue&type=style&index=0&id=27bfb399&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bfb399"]])

export default __exports__